export const ProjectColor = {
  starcheck: "#266bf0",
  log: "#50D05D",
  tokyo: " #E42E30",
  vlx: "#0C0C0C",
};
